// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__UfQCb","noInteraction":"EventWrapper_noInteraction__3I-d0"};